export enum ConfigActionTypes {
  GET_UNI_CONFIG = '@@visa/GET_UNI_CONFIG',
  GET_UNI_CONFIG_SUCCESS = '@@visa/GET_UNI_CONFIG_SUCCESS',
  GET_UNI_CONFIG_FAILURE = '@@visa/GET_UNI_CONFIG_FAILURE',
  GET_NAVIGATION_URLS = '@@config/GET_NAVIGATION_URLS',
  GET_NAVIGATION_URLS_SUCCESS = '@@config/GET_NAVIGATION_URLS_SUCCESS',
  GET_NAVIGATION_URLS_FAILURE = '@@config/GET_NAVIGATION_URLS_FAILURE'
}
